var React = require('react');

function AlopexLogoInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"id":"logoGradient","gradientTransform":"rotate(0)"},[React.createElement("stop",{"offset":"5%","stopColor":"rgb(156, 39, 176)","key":0}),React.createElement("stop",{"offset":"95%","stopColor":"rgb(101, 201, 222)","key":1})])),React.createElement("title",{"key":1},"Alopex Logo"),React.createElement("path",{"d":"M7.67,38.4,0,.5,29.91,29.3,60,0,52.52,38.4,29.91,80Zm23,37.2L50.73,38.5,30.66,31.4Zm-1.42,0V31.4L9.37,38.5ZM51.29,37.1,57.73,4.3,31.32,30ZM8.9,37.1,28.58,30,2.37,4.8Z","key":2})]);
}

AlopexLogoInline.defaultProps = {"id":"Alopex Logo","className":"svgLogo","data-name":"svgLogo","viewBox":"0 0 60 80"};

module.exports = AlopexLogoInline;

AlopexLogoInline.default = AlopexLogoInline;
